<template>
  <profile-customer-review
    title="Review and confirm customer update"
    confirm-button-text="update customer"
    :profile="profile"
    :data="customerData"
    mode="update"
    :confirm-button-props="{ disabled: updateCustomerApiRequest.loading }"
    :cancel-button-props="{ disabled: updateCustomerApiRequest.loading }"
    @confirm="onConfirmButtonClick"
    @cancel="closeModal"
  />
</template>

<script>
  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileCustomerApi from '@/services/Api/ProfileCustomerApi'

  // Events
  import { EVENT_PROFILE_CUSTOMER_UPDATE } from '@/events/profileCustomers'

  // Mixins
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import ProfileCustomerReview from '@/components/profile-customers/ProfileCustomerReview'

  export default {
    name: 'ProfileCustomerUpdateModal',
    components: {
      ProfileCustomerReview
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        updateCustomerApiRequest: new ApiRequest(ProfileCustomerApi.update)
      }
    },
    computed: {
      profile () {
        return this.modalData.profile
      },
      customerData () {
        return this.modalData.customer
      }
    },
    methods: {
      onConfirmButtonClick () {
        const { id: customerId, ...restCustomerData } = this.customerData

        this.updateCustomerApiRequest.execute(customerId, restCustomerData)
          .then(() => {
            this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_UPDATE, { ...this.customerData, parentProfileId: this.profile.id })
            this.showSuccessFlashMessage('Customer has been successfully updated.')
          })
          .catch(error => {
            this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_UPDATE, error)
            this.showErrorFlashMessage('Customer has not been updated.')
          })
      }
    }
  }
</script>
